import { z } from 'zod';

// Configure before importing application schemas: the browser CSP forbids dynamic code evaluation.
z.config({ jitless: true });
